import React from "react"
import styled from "styled-components"

import Tag, { SizeType } from "~/components/atoms/Tag"
import { Color } from "~/consts/style-mixins"

type Props = {
  size?: SizeType
}

export const CampaignRequireTag: React.VFC<Props> = ({ size = "Medium" }) => {
  return (
    <StyledTag size={size} color={Color.Attention}>
      キャンペーン必須項目
    </StyledTag>
  )
}

const StyledTag = styled(Tag)`
  display: inline-block;
  flex-shrink: 0;
`

export const CampaignRecommendTag: React.VFC<Props> = ({ size = "Medium" }) => {
  return (
    <StyledWhiteoutTag size={size} color="">
      キャンペーン推奨項目
    </StyledWhiteoutTag>
  )
}

const StyledWhiteoutTag = styled(Tag)`
  display: inline-block;
  border: 1px solid ${Color.Attention};
  background-color: ${Color.AttentionLight};
  color: ${Color.Attention};
`
